import { render, staticRenderFns } from "./ClinicalPlacements.vue?vue&type=template&id=21babd3a&scoped=true"
import script from "./ClinicalPlacements.vue?vue&type=script&lang=js"
export * from "./ClinicalPlacements.vue?vue&type=script&lang=js"
import style0 from "./ClinicalPlacements.vue?vue&type=style&index=0&id=21babd3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21babd3a",
  null
  
)

export default component.exports